"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.backupStorage = void 0;
var defaults_1 = __importDefault(require("lodash/defaults"));
var omit_1 = __importDefault(require("lodash/omit"));
var get_1 = __importDefault(require("lodash/get"));
var values_1 = __importDefault(require("lodash/values"));
var includes_1 = __importDefault(require("lodash/includes"));
var axios_1 = __importDefault(require("axios"));
var MemoryStorage_1 = __importDefault(require("./libs/MemoryStorage"));
var constants_1 = require("./constants");
var type_1 = require("./type");
var globalNamespace_1 = require("./globalNamespace");
var utils_1 = require("./utils");
exports.backupStorage = new MemoryStorage_1.default();
var Passport = /** @class */ (function () {
    function Passport(clientId, clientName, options) {
        if (options === void 0) { options = {}; }
        this.clientId = clientId;
        this.clientName = clientName;
        this.options = (0, defaults_1.default)(options, {
            baseAuthServer: constants_1.AUTH_SERVER,
            storeKeyPrefix: 'patsnap',
            accessTokenExpiredMS: 30 * 60 * 1000,
            refreshTokenExpiredMS: 2 * 60 * 60 * 1000, // 2 hours
        });
        this.requester = axios_1.default.create({
            baseURL: this.options.baseAuthServer,
            timeout: 30000,
            withCredentials: true,
            headers: {
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json',
            },
        });
        this.requester.defaults.headers.common['X-Requested-With'] =
            'XMLHttpRequest';
        this.localStorageLikeStore = localStorage;
        if (MemoryStorage_1.default.getIsEnabled()) {
            this.localStorageLikeStore = exports.backupStorage;
            this.removeLocal();
        }
    }
    Object.defineProperty(Passport.prototype, "passportRuntimeOptions", {
        get: function () {
            return (0, globalNamespace_1.getGlobalNamespace)().passportRuntimeOptions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Passport.prototype, "requestParams", {
        get: function () {
            var oriParams = {
                from: this.clientName,
                client_id: this.clientId,
                response_type: 'TOKEN',
            };
            return this.syncTokenParamsModifier(oriParams);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Passport.prototype, "storeItemKey", {
        get: function () {
            return "".concat(this.options.storeKeyPrefix, "-authorizations");
        },
        enumerable: false,
        configurable: true
    });
    Passport.prototype.removeLocal = function () {
        try {
            localStorage.removeItem(this.storeItemKey);
        }
        catch (e) {
            console.error(e);
        }
    };
    Passport.prototype.tryStoreItem = function (key, value) {
        try {
            this.localStorageLikeStore.setItem(key, value);
        }
        catch (e) {
            this.localStorageLikeStore = exports.backupStorage;
            this.localStorageLikeStore.setItem(key, value);
            this.removeLocal();
            MemoryStorage_1.default.enableOnTopDomain();
            console.error(e);
        }
    };
    Passport.prototype.afterStoreToken = function (token, refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    Passport.prototype.syncTokenParamsModifier = function (params) {
        return params;
    };
    Passport.prototype.updateTokensFromOutSide = function (token, refreshToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.storeTokensInLocalStorage(token, refreshToken);
                        return [4 /*yield*/, this.afterStoreToken(token, refreshToken)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Passport.prototype.storeTokensInLocalStorage = function (token, refreshToken) {
        var now = new Date().getTime();
        return this.tryStoreItem(this.storeItemKey, JSON.stringify({
            token: token,
            refreshToken: refreshToken,
            tokenExpires: now + this.options.accessTokenExpiredMS - 60000,
            refreshTokenExpires: now + this.options.refreshTokenExpiredMS - 60000,
        }));
    };
    Passport.prototype.getToken = function (type) {
        var now = new Date().getTime();
        var tokenParis = JSON.parse(this.localStorageLikeStore.getItem(this.storeItemKey) || '{}');
        if (!tokenParis[type] || tokenParis["".concat(type, "Expires")] < now) {
            return null;
        }
        return tokenParis[type];
    };
    Passport.prototype.expireToken = function (type) {
        var tokenParis = JSON.parse(this.localStorageLikeStore.getItem(this.storeItemKey) || '{}');
        return this.tryStoreItem(this.storeItemKey, JSON.stringify((0, omit_1.default)(tokenParis, [type, "".concat(type, "Expires")])));
    };
    Passport.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requester.get(constants_1.DESTROY_SESSION_PATH)];
                    case 1:
                        data = _a.sent();
                        this.localStorageLikeStore.removeItem("".concat(this.options.storeKeyPrefix, "-authorizations"));
                        return [2 /*return*/, data];
                }
            });
        });
    };
    Passport.prototype.exchangeRefreshForAccess = function () {
        return __awaiter(this, void 0, void 0, function () {
            var refreshToken, response, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        refreshToken = this.getToken('refreshToken');
                        /* istanbul ignore next */
                        if (!refreshToken) {
                            throw new Error('no refreshToken found');
                        }
                        return [4 /*yield*/, this.requester.post(constants_1.EXCHANGE_ACCESS_TOKEN_PATH, __assign(__assign({}, this.requestParams), { refresh_token: refreshToken }), {
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                            })];
                    case 1:
                        response = _a.sent();
                        token = response.data.token;
                        if (!token) {
                            // refreshtoken 200但没有token
                            return [2 /*return*/, Promise.reject(response.data)];
                        }
                        this.storeTokensInLocalStorage(token, refreshToken);
                        return [4 /*yield*/, this.afterStoreToken(token, refreshToken)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    Passport.prototype.syncTokensWithPassport = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, _a, token, refreshToken, errcode, msg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.requester.get(constants_1.SYNC_TOKEN_PAIRS_PATH, {
                            params: this.requestParams,
                        })];
                    case 1:
                        res = _b.sent();
                        _a = res.data, token = _a.token, refreshToken = _a.refresh_token, errcode = _a.errcode;
                        if (errcode) {
                            // checksession 出错了也是200 Ok
                            throw this.createErrorWithErrcode(errcode);
                        }
                        if (!token || !refreshToken) {
                            msg = "Unable get Token from checksession: ".concat(JSON.stringify(res));
                            console.error(msg);
                            throw new Error(msg);
                        }
                        this.storeTokensInLocalStorage(token, refreshToken);
                        return [4 /*yield*/, this.afterStoreToken(token, refreshToken)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, token];
                }
            });
        });
    };
    Passport.prototype.getErrcodeFromError = function (err) {
        return (0, get_1.default)(err, 'numeric_error_code') || (0, get_1.default)(err, 'response.data.numeric_error_code')
            || (0, get_1.default)(err, 'errcode') || (0, get_1.default)(err, 'response.data.errcode');
    };
    Passport.prototype.createErrorWithErrcode = function (errorOrCode) {
        var argType = typeof errorOrCode;
        var code;
        if (argType === 'string' || argType === 'number') {
            code = String(errorOrCode);
        }
        else {
            code = this.getErrcodeFromError(errorOrCode);
        }
        var error = new type_1.PassportError(String(code));
        code = String(code);
        error.errcode = code;
        if ((0, includes_1.default)((0, values_1.default)(constants_1.NEED_RELOGIN_ERROR_CODES), code)) {
            error.passportErrorType = constants_1.ERROR_TYPE.AUTH;
        }
        else if ((0, includes_1.default)((0, values_1.default)(constants_1.NEED_PAYMENT_ERROR_CODES), code)) {
            error.passportErrorType = constants_1.ERROR_TYPE.PAYMENT;
        }
        error.data = (0, get_1.default)(errorOrCode, 'response.data');
        return error;
    };
    Passport.prototype.onTokenSessionMissMatchHook = function (response) {
        return true;
    };
    Passport.prototype.onTokenSessionMissMatch = function (response) {
        return __awaiter(this, void 0, void 0, function () {
            var allowNextStep;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        allowNextStep = this.onTokenSessionMissMatchHook(response);
                        if (!(allowNextStep !== false)) return [3 /*break*/, 2];
                        this.localStorageLikeStore.removeItem("".concat(this.options.storeKeyPrefix, "-authorizations"));
                        window.location.reload();
                        // 睡8秒，等待页面刷新，阻止后续的代码在正在刷新时继续执行
                        return [4 /*yield*/, (0, utils_1.waitJumpout)()];
                    case 1:
                        // 睡8秒，等待页面刷新，阻止后续的代码在正在刷新时继续执行
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Passport.prototype.getAccessToken = function (forceRefetch) {
        if (forceRefetch === void 0) { forceRefetch = false; }
        return __awaiter(this, void 0, void 0, function () {
            function postProcessGetTokenError(error) {
                return __awaiter(this, void 0, void 0, function () {
                    var onHoldingPassportError;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!((0, get_1.default)(error, 'response.status') === constants_1.TOKEN_SESSION_MISSMATCH_HTTP_CODE)) return [3 /*break*/, 2];
                                return [4 /*yield*/, self.onTokenSessionMissMatch(error.response)];
                            case 1:
                                _a.sent();
                                throw self.createErrorWithErrcode(String(constants_1.TOKEN_SESSION_MISSMATCH_HTTP_CODE));
                            case 2:
                                onHoldingPassportError = self.createErrorWithErrcode(error);
                                if (Object.values(constants_1.ERROR_TYPE).includes(onHoldingPassportError.passportErrorType)) {
                                    throw onHoldingPassportError;
                                }
                                else {
                                    // 其他错误，不应该throw，因为可能只是refreshToken错误，下面checksession会再次尝试，再不行才throw
                                    console.error('[postProcessGetTokenError] unexpected error', error);
                                }
                                _a.label = 3;
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            }
            var self, accessToken, refreshToken, e_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        self = this;
                        accessToken = this.getToken('token');
                        if (!forceRefetch && accessToken) {
                            return [2 /*return*/, accessToken];
                        }
                        refreshToken = this.getToken('refreshToken');
                        if (!refreshToken) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, this.exchangeRefreshForAccess()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_1 = _a.sent();
                        return [4 /*yield*/, postProcessGetTokenError(e_1)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        _a.trys.push([5, 7, , 9]);
                        return [4 /*yield*/, this.syncTokensWithPassport()];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7:
                        e_2 = _a.sent();
                        return [4 /*yield*/, postProcessGetTokenError(e_2)];
                    case 8:
                        _a.sent();
                        throw e_2;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Passport.prototype.getCaptcha = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var res, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requester.get(constants_1.CAPTCHA_PATH, {
                            params: params,
                        })];
                    case 1:
                        res = _a.sent();
                        if (res.status === 200) {
                            data = res.data;
                            if (data) {
                                return [2 /*return*/, res.data];
                            }
                            return [2 /*return*/, {}];
                        }
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return Passport;
}());
exports.default = Passport;
//# sourceMappingURL=passport.js.map